import React from 'react';
import PropTypes from 'prop-types';

import '../css/finalize-team.css';

class FinalizeTeam extends React.Component {

  static propTypes = {
    selections: PropTypes.object,
    isFinished: PropTypes.bool,
    userIsFinished: PropTypes.func,
  }

  render() {

    const numSelections = Object.keys(this.props.selections).length;
    const isFinished = this.props.isFinished;

    const apNums = ['zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine']
    
    return (
      <div
        className={numSelections === 0 || isFinished === true ? 'no-show finalize-team__container' : 'finalize-team__container'}
      >
        <p className="benton-regular">You’ve added&nbsp;
          {numSelections < 10 ? apNums[numSelections] : numSelections}
          {numSelections === 1 ? ' player ': ' players '}
          to your Patriots roster. Continue adding players while staying under the salary cap, or click the button below to finalize your roster.
        </p>

          <button
            className="button--red button--centered button--large finalize-team__button"
            onClick={this.props.userIsFinished}
          >
            Finalize my team
          </button>

      </div>
    )
  }
}

export default FinalizeTeam;